"use client";

import { useMemo, useState } from "react";

import { ToolFrame } from "@/components/tools/ToolFrame";

export function MoqImpactCalculatorClient() {
  const [monthlyDemand, setMonthlyDemand] = useState(300);
  const [moq, setMoq] = useState(500);
  const [unitCost, setUnitCost] = useState(18);
  const [holdingCostPct, setHoldingCostPct] = useState(22);

  const cycles = useMemo(() => (monthlyDemand > 0 ? monthlyDemand / moq : 0), [monthlyDemand, moq]);
  const avgExcess = useMemo(() => Math.max(0, moq - monthlyDemand), [moq, monthlyDemand]);
  const tiedCash = useMemo(() => avgExcess * unitCost, [avgExcess, unitCost]);
  const annualHolding = useMemo(() => tiedCash * (holdingCostPct / 100), [tiedCash, holdingCostPct]);

  return (
    <ToolFrame
      toolKey="moq-impact-calculator"
      title="MOQ Impact Calculator"
      embedPath="/embed/moq-impact-calculator"
      exportCsvRows={[{ monthlyDemand, moq, unitCost, holdingCostPct, cyclesPerMonth: cycles.toFixed(2), avgExcess, tiedCash, annualHolding }]}
    >
      <div className="ed-card-glass" style={{ maxWidth: "520px", padding: "1rem", borderRadius: "12px", display: "grid", gap: ".65rem" }}>
        <Field label="Monthly demand (units)" value={monthlyDemand} onChange={setMonthlyDemand} />
        <Field label="Supplier MOQ (units)" value={moq} onChange={setMoq} />
        <Field label="Unit cost (R)" value={unitCost} onChange={setUnitCost} />
        <Field label="Annual holding cost %" value={holdingCostPct} onChange={setHoldingCostPct} />
        <div style={{ marginTop: ".35rem", borderTop: "1px solid rgba(148,163,184,.25)", paddingTop: ".7rem", color: "#334155", lineHeight: 1.65 }}>
          <div>Order cycles/month: <strong>{cycles.toFixed(2)}</strong></div>
          <div>Excess units carried: <strong>{avgExcess}</strong></div>
          <div>Cash tied by MOQ: <strong>R {tiedCash.toFixed(2)}</strong></div>
          <div>Estimated annual carrying cost: <strong>R {annualHolding.toFixed(2)}</strong></div>
        </div>
      </div>
    </ToolFrame>
  );
}

function Field({ label, value, onChange }: { label: string; value: number; onChange: (v: number) => void }) {
  return (
    <label style={{ display: "grid", gap: ".3rem", fontSize: ".85rem", color: "#475569" }}>
      {label}
      <input
        type="number"
        value={value}
        onChange={(e) => onChange(Number(e.target.value || 0))}
        style={{ width: "100%", padding: ".55rem .65rem", borderRadius: "8px", border: "1px solid rgba(148,163,184,.45)", boxSizing: "border-box" }}
      />
    </label>
  );
}

